import { FC, PropsWithChildren } from "react";
import { Address } from "viem";
import { useDisclosure } from "@chakra-ui/react";
import { Popover } from "@looksrare/uikit";
import { ProfileNav } from "@/components/ProfileNav";
import { ReferralModal } from "@/components/Modals";

interface ProfileNavPopoverProps {
  address?: Address;
}

export const ProfileNavPopover: FC<PropsWithChildren<ProfileNavPopoverProps>> = ({ address, children }) => {
  const referralModalDisclosure = useDisclosure();

  return (
    <>
      <Popover
        arrowSize={0}
        gutter={4}
        variant="menu"
        arrowProps={{
          display: "none",
        }}
        contentProps={{
          maxHeight: "85vh",
          overflowY: "auto",
        }}
        label={<ProfileNav address={address} onOpenReferralModal={referralModalDisclosure.onOpen} />}
        placement="bottom"
      >
        {children}
      </Popover>
      <ReferralModal {...referralModalDisclosure} />
    </>
  );
};
